// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SimpleTable_root_3iFxY{color:#313a46}.SimpleTable_cells_1GJkl{flex-grow:1}.SimpleTable_cells_1GJkl,.SimpleTable_row_2_Hyt{display:flex;align-items:center}.SimpleTable_row_2_Hyt{min-height:60px}.SimpleTable_row_2_Hyt.SimpleTable_header_2RRLV{border-bottom:1px dashed #e0e3e8}.SimpleTable_row_2_Hyt.SimpleTable_pointer_3jtxf{cursor:pointer}.SimpleTable_row_2_Hyt.SimpleTable_pointer_3jtxf:hover:not(.SimpleTable_header_2RRLV){background:#eef2f7;border-radius:10px}.SimpleTable_cell_2R6XC{padding:0 16px}.SimpleTable_cell_2R6XC.SimpleTable_right_2hXw0{text-align:right}.SimpleTable_grow_n951I{flex-grow:1}.SimpleTable_iconWidth_VaY1F{width:26px}", ""]);
// Exports
exports.locals = {
	"root": "SimpleTable_root_3iFxY",
	"cells": "SimpleTable_cells_1GJkl",
	"row": "SimpleTable_row_2_Hyt",
	"header": "SimpleTable_header_2RRLV",
	"pointer": "SimpleTable_pointer_3jtxf",
	"cell": "SimpleTable_cell_2R6XC",
	"right": "SimpleTable_right_2hXw0",
	"grow": "SimpleTable_grow_n951I",
	"iconWidth": "SimpleTable_iconWidth_VaY1F"
};
module.exports = exports;
